<script setup lang="ts">
import type { IOverviewAuthorList } from "~/types";
import AuthorCard from "~/components/AuthorCard.vue";

const props = defineProps<IOverviewAuthorList>();

const terminology = useTerminologyStore();
</script>
<template>
  <section :id="`topic-${topicTitle}`" class="Overview__Authors">
    <h2>{{ terminology.getTerm("topicTitle") }} {{ topicTitle }}</h2>
    <ul class="Overview__Authors__Cards">
      <li
        v-for="author in props.topicEditorsOrCoordinators"
        :key="author.userId">
        <AuthorCard v-bind="author" />
      </li>
    </ul>
  </section>
</template>

<style lang="scss">
.Overview__Authors {
  &__Cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    margin-bottom: 32px;

    @media #{$break-laptop} {
      max-width: none;
      grid-template-columns: repeat(2, 1fr);
    }

    @media #{$break-xs} {
      grid-template-columns: repeat(1, 1fr);
    }

    a {
      display: grid;
      height: 100%;
    }
  }
}
</style>
